const contactEn = {
  breadcrumbs: { home: 'Home', contact: 'Contact' },
  hero: {
    title: 'Get in touch with us',
    subtitle: 'We are here to help with any questions, feedback, or support'
  },
  quick: {
    title: 'Get help quickly',
    actions: {
      liveChat: { title: 'Live Chat', desc: 'Get instant assistance', cta: 'Start Chat' },
      helpCenter: { title: 'Help Center', desc: 'Answers to common questions', cta: 'View Help' },
      business: { title: 'Business Enquiry', desc: 'Partnerships & collaborations', cta: 'Contact Us' }
    }
  },
  info: {
    title: 'Contact Information',
    service: { title: 'Customer Service', desc: '9 AM to 9 PM' },
    email: { title: 'Email', desc: 'We reply within 24 hours' },
    address: {
      title: 'Address',
      desc: 'Saturday to Thursday, 9 AM - 6 PM',
      primary: 'House #12, College Road,',
      secondary: 'Dukha Fakir Mor, Gurudaspur, Natore - 6440'
    }
  },
  form: {
    title: 'Send a message',
    desc: 'Fill out the form with your details. We will contact you within 24 hours.',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    subject: 'Subject',
    message: 'Message',
    messagePh: 'Write your question or comments in detail...',
    submit: 'Send',
    success: 'Your message has been sent successfully. We will contact you soon.'
  },
  hours: {
    title: 'Office Hours',
    weekdays: 'Saturday - Thursday',
    friday: 'Friday',
    note: 'On Fridays our office operations are limited due to public holiday'
  },
  social: { title: 'Social Media' },
  faq: {
    title: 'Frequently Asked Questions',
    subtitle: 'You may find your answer in our help section',
    cta: 'Visit Help Center'
  }
};

export default contactEn;


